package com.iregained.site.components.sections.clinicians.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val EvidenceContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White) // Alternating rhythm
}

val EvidenceGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1440.px).gap(40.px)
}

val EvidenceCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(32.px).borderRadius(12.px)
            .backgroundColor(colorMode.toSitePalette().nearBackground) // Subtle pop against white
            .transition(Transition.of("all", 200.ms)).boxShadow(0.px, 0.px, 0.px, color = Colors.Transparent)
            .translateY(0.px)
    }
    hover {
        Modifier.boxShadow(0.px, 8.px, 20.px, color = Colors.Black.copy(alpha = 10))
            .translateY((-4).px) // Subtle lift on hover to indicate clickability
    }
}

val EvidenceCardIconStyle = CssStyle.base {
    Modifier.size(48.px).margin(bottom = 24.px)
}

val EvidenceCardTitleStyle = CssStyle.base {
    Modifier.fontSize(24.px).fontWeight(FontWeight.Bold).color(colorMode.toSitePalette().custom.darkText)
        .margin(bottom = 12.px)
}

val EvidenceCardDescStyle = CssStyle.base {
    Modifier.fontSize(16.px).color(colorMode.toSitePalette().custom.darkText.toRgb().copyf(alpha = 0.8f))
        .margin(bottom = 24.px).lineHeight(1.6)
        .flexGrow(1) // Ensures uniform link placement across varying description heights
}

val EvidenceCardLinkStyle = CssStyle {
    base {
        Modifier.color(colorMode.toSitePalette().brand.primary).fontWeight(FontWeight.Bold).fontSize(16.px)
            .textDecorationLine(TextDecorationLine.None).transition(Transition.of("color", 200.ms))
    }
    hover {
        Modifier.color(colorMode.toSitePalette().brand.primaryHover)
    }
}